export default "__VITE_ASSET__AwCgl5uu__"